export const FILE_NAME_REGEX = /^[a-z0-9A-Z\-_]+$/;
